export const initTechSwiper = () => {
  const swiperElements = document.querySelectorAll(".tech-attrs-swiper");
  if (swiperElements.length === 0 || !window.SwiperGlobal) return;

  swiperElements.forEach((el) => {
    new window.SwiperGlobal(el, {
      slidesPerView: "auto",
      spaceBetween: 0,
      grabCursor: true,
      watchOverflow: true,

      pagination: false,

      observer: true,
      observeParents: true,
      breakpoints: {
        992: {
          enabled: false,
        },
      },
    });
  });
};
